import grapesjs from 'grapesjs';
import type {Editor, EditorConfig} from 'grapesjs';
import GRAPESJS_CONFIG from './config/grapesjs';

export function initializeEditor(container: HTMLElement): Editor {
  // cssIcons / blockManager are intentionally null at runtime to disable GrapesJS defaults
  // (see config/grapesjs.ts); cast at the init boundary since EditorConfig types them as
  // non-null.
  return grapesjs.init({
    ...GRAPESJS_CONFIG,
    container,
  } as EditorConfig);
}
